import { NavLink } from 'react-router-dom';
import { useVisibleInstallerNavItems } from './InstallerBottomNav';

/**
 * Desktop (lg+) tab strip under the Header for the installer shell. The mobile
 * bottom nav is `lg:hidden`, so without this an installer on desktop has no way
 * to switch between "Planning" and "Mijn werk". Reuses the same gated item list.
 *
 * Hidden on mobile (the bottom nav covers it) and rendered only when there are
 * 2+ tabs — an employee with a single page gets no redundant switcher.
 */
export function InstallerDesktopNav() {
  const visibleItems = useVisibleInstallerNavItems();
  if (visibleItems.length < 2) return null;

  return (
    <nav className="hidden lg:block bg-white border-b border-gray-200">
      <div className="max-w-4xl mx-auto px-4 flex gap-1">
        {visibleItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 -mb-px ${
                isActive
                  ? 'text-td-blue border-td-blue'
                  : 'text-gray-500 border-transparent hover:text-td-navy'
              }`
            }
          >
            <span className="w-5 h-5 [&>svg]:w-5 [&>svg]:h-5">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
